<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="back()"></div>
            <div class="modal">
                <article v-if="resource">

                    <header>
                        <figure>
                            <img :src="$iconFolder + 'user-woman.svg'" v-if="!resource.picture && resource.gender && resource.gender.id == 'f'"/>
                            <img :src="$iconFolder + 'user-man.svg'" v-else/>
                            <img v-if="resource.picture" :src="resource.picture.url+'/fit/100x100'"/>
                        </figure>
                        <div>
                            <span class="breadcrumb">
                                Profile <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1 v-if="resource.addresses && resource.addresses.length && resource.addresses[0].company">{{ resource.addresses[0].company }}, {{ resource.firstname + " " + resource.lastname }}</h1>
                            <h1 v-else>{{ resource.firstname ? resource.firstname + " " + resource.lastname : 'Nouveau' }}</h1>
                            <div v-if="resource.addresses && resource.addresses.length > 0" style="margin-top: 0.25em;white-space: nowrap;">
                              <p><strong v-if="resource.addresses[0].company">{{ resource.addresses[0].company }}, </strong>{{ resource.addresses[0].street }} {{ resource.addresses[0].street_number }}, {{ resource.addresses[0].country_id }}-{{ resource.addresses[0].postal_code }} {{ resource.addresses[0].locality }}</p>
                            </div>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                    </header>

                    <main>

                         <languages :translations="resource.translations" :localesLoaded="localesLoaded" :locales="locales" v-model="locale"></languages>

                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Information">

                              <form-scopes label='Scopes' v-model="resource"></form-scopes>

                              <fieldset>
                                <h3>Détail du contact</h3>
                                <p class="headline"></p>

                                <form-text label="Numéro de client (interne)" v-model="resource.internal_identifier"></form-text>

                                <form-select-new label="Genre" multiple="false" v-model="resource.gender" :options="genders"></form-select-new>

                                <group-line-2>
                                <form-text label="Prénom" v-model="resource.firstname" required="true"></form-text>
                                <form-text label="Nom" v-model="resource.lastname" required="true"></form-text>
                                </group-line-2>

                                <form-datex label="Date naissance" v-model="resource.birthdate" :hide-time="true"></form-datex>
                                <form-select-new label="Locales" multiple="false" v-model="resource.locale" :options="$store.state.locales"></form-select-new>


                              </fieldset>

                              <fieldset>
                                <h3>Attributs du contact</h3>
                                <p class="headline"></p>

                                <component-attributes v-model="resource" :locale="locale"></component-attributes>

                              </fieldset>

                            </tab>
                            <tab name="Avancé">
                              <fieldset>
                                <h3>Paramètres avancés</h3>
                                <p class="headline"></p>

                                <form-toggle label="Human" v-model="resource.is_human"></form-toggle>

                                <form-file label='Image' v-model="resource.picture_id" width="200"></form-file>

                                <form-select label="Companies" multiple="true" v-model="resource.companies" id="id" :options="companies" v-if="companies"></form-select>

                                <form-tag label="Tags" v-model="resource.tags"></form-tag>

                                <form-toggle label="Newsletter Subscription" v-model="resource.subscribed_to_newsletter"></form-toggle>

                                <form-toggle label="SMS Subscription" v-model="resource.subscribed_to_sms"></form-toggle>

                                <form-textarea label="Commentaire" v-model="resource.comment"></form-textarea>

                              </fieldset>
                            </tab>
                            <tab name="Adresses">

                              <fieldset>
                                <h3>Adresses</h3>
                                <p class="headline"></p>

                                <component-address v-model="resource.addresses"></component-address>

                              </fieldset>

                            </tab>
                            <tab name="Facturation">

                              <fieldset>
                                <h3>Conditions de facturation</h3>
                                <p class="headline"></p>

                                <form-select-new label="Succursale" multiple="false"
                                              v-model="resource.branch"
                                              :default="resource.branch_id"
                                              :options="branches"></form-select-new>

                                <form-select-new label="Geste commercial"
                                                 multiple="false"
                                                 v-model="resource.commercial_gesture"
                                                 :default="resource.commercial_gesture_id"
                                                 :options="commercialGestures"
                                                 v-if="commercialGestures"></form-select-new>

                                <form-select-new label="Conditions de paiement (par défaut)" multiple="false"
                                             v-model="resource.payment_condition"
                                             :options="$store.getters.scope.payment_conditions"></form-select-new>

                              </fieldset>

                            </tab>
                            <tab name="Historique commandes" v-if="resource.id">

                              <fieldset>
                                <h3>Flux d'achats</h3>
                                <p class="headline"></p>
                                <timeline v-model="resource.customer_orders_workflow"/>
                              </fieldset>

                              <fieldset>
                                <h3>Détail des commandes passées</h3>
                                <order-person-widget :person_id="resource.id"></order-person-widget>
                              </fieldset>

                            </tab>
                            <tab v-if="$aclInterfaceValidator('is_super_admin')" name="Authentification">

                              <fieldset>
                                <h3>Compte de connexion</h3>
                                <p class="headline"></p>

                                <form-toggle label="Account" v-model="has_account" :callback="updateAccount"></form-toggle>

                                <fieldset v-show="has_account" v-if="resource.user">
                                    <h3>Compte de l'utilisateur</h3>
                                  <p class="headline"></p>

                                    <div class="notice error" v-if="!resource.user.approved">Le compte n'est pas encore approuvé par l'administrateur</div>

                                    <form-toggle label="Compte approuvé" v-model="resource.user.approved" v-if="!user_is_approved"></form-toggle>
                                    <form-text label="Username" v-model="resource.user.email"></form-text>
                                    <form-password label="Mot de passe" v-model="resource.user.password"></form-password>
                                    <div class="form-field" v-if="resource.email && resource.user.password && resource.user.email">
                                      <div class="form-label"></div>
                                      <div class="form-input">
                                        <div class="form-input-wrapper" style="background: none; box-shadow: none;border:0;display:flex;">
                                          <label style="width: 80%;">Notifier le changement de mot de passe à l'utilisateur.<br>Un mail sera envoyé à {{ resource.email }}</label>
                                          <form-toggle label="" v-model="resource.user.notify"></form-toggle>
                                        </div>
                                      </div>
                                    </div>


                                    <form-toggle label="Double authentification" v-model="resource.user.has_two_factor"></form-toggle>

                                    <form-toggle label="Actif" v-model="resource.user.active" :callback="updateAccountActive"></form-toggle>
                                    <div v-if="resource.user.active">
                                        <form-date label="Date start" v-model="resource.user.activated_at" format="yyyy-MM-dd"></form-date>
                                        <form-date label="Date end" v-model="resource.user.terminated_at" format="yyyy-MM-dd" time="23:59:59"></form-date>
                                    </div>

                                    <form-select-new label="Scopes"
                                                 multiple="true"
                                                 v-model="resource.user.scopes"
                                                 :options="scopes" v-if="scopes"
                                                 :callback="updateRole"></form-select-new>

                                  <div class="form-field form-roles" v-if="resource.user.scopes && resource.user.scopes.length">
                                        <div class="form-label">
                                            <label>Roles</label>
                                        </div>
                                        <div class="form-input">
                                            <div class="form-input-wrapper">
                                                <div v-for="scope in resource.user.scopes">
                                                    <div class="image">
                                                        <label class="label scope" v-bind:style="{background:scope.color}">{{ scope.slug.substr(0,1) }}</label>
                                                    </div>
                                                    <div class="name">{{ scope.name }}</div>
                                                    <div>
                                                        <label v-for="role in roles"><input type="radio" :value="role.id" :name="'group_'+scope.id" v-model="scope.role_id"/> {{ role.label }}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>

                              </fieldset>

                            </tab>
                            <tab name="Authorization">
                                <acl-authorizations v-model="resource.acl" model="Maven.WeeboxCore.Models.Person" type="entity"></acl-authorizations>
                            </tab>
                        </tabs>

                    </main>
                    <footer>
                    </footer>
                </article>

            </div>
        </div>
    </transition>
</template>
<script>

    import PersonService from './PersonService.js';
    import ScopeService from '../scope/ScopeService.js';
    import CompanyService from '../company/CompanyService.js';

    import ComponentAddress from "../../components/Address.vue";
    import ComponentAttributes from "../../components/Attributes.vue";

    import Edit from '../../layouts/Edit.vue';
    import OrderByPersonWidget from '../shop/order/OrderByPersonWidget.vue'
    import CommercialGestureService from '../shop/commercial-gesture/CommercialGestureService.js'
    import BranchService from "../config/branch/BranchService";

    export default {
        extends: Edit,
        components: {
            'component-address': ComponentAddress,
            'component-attributes': ComponentAttributes,
            'order-person-widget': OrderByPersonWidget
        },
        data () {
            return {
                attributes: [],
                resource: {
                    companies: [],
                    user: {
                        workspaces: []
                    }
                },
                branches: [],
                options: [],
                companies: [],
                scopes: [],
                roles: [
                    {id: 1, label: 'Superadmin'},
                    {id: 2, label: 'Administrator'},
                    {id: 3, label: 'Moderator'},
                    {id: 4, label: 'User'}
                ],
                genders: [
                    {id: 'f', name: 'Madame'},
                    {id: 'm', name: 'Monsieur'}
                ],
                user_is_approved: false,
                isLoading: false,
                resourceModal: null,
                has_account: false,
                commercialGestures: null
            }
        },
        mounted: function(){

            this.resourceModal = this.resource || {};

            ScopeService.query().then(response => {
                this.scopes = response.data.data
                this.isLoading = false
            })

            CompanyService.all().then(response => {
                this.companies = response.data
                this.isLoading = false
            })

            CommercialGestureService.all().then(response => {
              this.commercialGestures = response.data
              this.isLoading = false
            })

            BranchService.query().then(response => {
              this.branches = response.data.data
              this.isLoading = false
            })

        },
        methods:{
            resourceLoaded: function(){
                this.localesLoaded = true;
                this.resource.is_human = this.resource.is_human == null ? true : this.resource.is_human;
                this.resource.addresses = this.resource.addresses || [];
                this.resource.user = this.resource.user || null;
                this.has_account = this.resource.user ? true : false;

                if( this.has_account )
                {
                  this.user_is_approved = this.resource.user.approved;
                }

                this.updateRole();
                this.$forceUpdate();
            },
            beforeUpdate: function(Resource){
                if( this.has_account === 0 ){
                    Resource.user = null;
                }
                return true
            },
            getResource: function(){
                return PersonService
            },
            createAccount(){
                this.resource.user = {
                    active: true,
                    email: "",
                    password: "",
                    workspaces: [],
                    role_scopes: [],
                    scopes: [],
                    activated_at: null,
                    terminated_at: null
                }
            },
            removeAccount(){
                this.resource.user = null
            },
            updateAccountActive:function(){
                if( this.resource.user.active )
                {
                    this.resource.user.terminated_at = null;
                }
            },
            updateAccount(){
                if( this.has_account )
                {
                    if( this.resource.user == null ){
                        this.createAccount();
                    }
                }
            },
            updateRole(){
                if( this.resource.user && this.resource.user.scopes.length ){

                    for(let item of this.resource.user.scopes){
                        let roleId = 4;
                        for(let role of this.resource.user.role_scopes){
                            if( item.id == role.scope_id ){
                                roleId = role.role_id;
                            }
                        }
                        item.role_id = roleId;
                    }

                }
                this.$forceUpdate();
            }
        },
        watch: {
            'resource'(newVal, oldVal) {
                console.log('RESOURCES',newVal);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/person/Edit.vue